module.exports = __webpack_public_path__ + "static/media/visualart.ac19326d.jpg";